import { render, staticRenderFns } from "./InstagramIntegration.vue?vue&type=template&id=6c822392&scoped=true&"
import script from "./InstagramIntegration.vue?vue&type=script&lang=js&"
export * from "./InstagramIntegration.vue?vue&type=script&lang=js&"
import style0 from "./InstagramIntegration.vue?vue&type=style&index=0&id=6c822392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c822392",
  null
  
)

export default component.exports